var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home-page"},[_c('HeroSection')],1),_c('div',[_c('ServicesSection')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }